import { Action } from '@ngrx/store';
import { Order } from '@cemex-core/cmx-api/models/order-management/order';
import { OrderDetailQueryParams } from '@ordersnproducts/modules/orders-and-product-catalog/modules/order-detail/constants/order-detail-query-params';

export enum ModifyOrderSelectedDetailActionTypes {
  LOAD = '[OrderSelectedDetail Modify] Load Modify order detail',
  UPDATE = '[Modify Order] Update attributes',
  LOAD_SUCCESS = '[OrderSelectedDetail Modify ] Load Modify order detail success',
  LOSET_PREFILLED_ORDER = '[OrderSelectedDetail Modify] Lose prefilled order',
  RESET_WO_PRICES = '[OrderSelectedDetail Modify] Reset without prices',
  RESET = '[OrderSelectedDetail Modify] Reset',
  LOAD_ONLINE = '[OrderSelectedDetail Modify] Load order ONLINE detail ',
  CREATE_RECIPES_MODIFY = '[OrderSelectedDetail Modify] Create recipes modify',
  CREATE_RECIPES_REQUEST_MODIFY = '[OrderSelectedDetail Modify] Load order recipes values REQUEST experience',
}

export class ModifyOrderUpdateData implements Action {
  readonly type = ModifyOrderSelectedDetailActionTypes.UPDATE;

  constructor(public payload: Partial<Order>) {}
}

export class ModifyOrderSelectedDetailLoad implements Action {
  readonly type = ModifyOrderSelectedDetailActionTypes.LOAD;

  constructor(public payload: OrderDetailQueryParams) {}
}

export class ModifyOrderSelectedDetailLoadSuccess implements Action {
  readonly type = ModifyOrderSelectedDetailActionTypes.LOAD_SUCCESS;

  constructor(public payload: Order) {}
}

export class ModifyOrderSelectedDetailResetWOPrices implements Action {
  readonly type = ModifyOrderSelectedDetailActionTypes.RESET_WO_PRICES;

  constructor(public payload: any) {}
}

export class ModifyOrderSelectedDetailReset implements Action {
  readonly type = ModifyOrderSelectedDetailActionTypes.RESET;

  constructor(public payload: any) {}
}
export class ModifyOrderSelectedCreateFormRecipes implements Action {
  readonly type = ModifyOrderSelectedDetailActionTypes.CREATE_RECIPES_MODIFY;
  constructor(public payload: Order) {}
}

export class ModifyOrderSelectedDetailOnline implements Action {
  readonly type = ModifyOrderSelectedDetailActionTypes.LOAD_ONLINE;

  constructor(public payload: Order) {}
}
export class ModifyRequestOrderSelectedCreateFormRecipes implements Action {
  readonly type = ModifyOrderSelectedDetailActionTypes.CREATE_RECIPES_REQUEST_MODIFY;
  constructor(public payload: Order) {}
}

export class ModifyOrderSelectedDetailLosePrefilledOrder implements Action {
  readonly type = ModifyOrderSelectedDetailActionTypes.LOSET_PREFILLED_ORDER;
  constructor() {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type OrderSelectedDetailActions =
  | ModifyOrderSelectedDetailLoad
  | ModifyOrderSelectedDetailLoadSuccess
  | ModifyOrderSelectedDetailReset
  | ModifyOrderSelectedDetailOnline
  | ModifyOrderSelectedCreateFormRecipes
  | ModifyOrderSelectedDetailResetWOPrices
  | ModifyOrderUpdateData
  | ModifyOrderSelectedDetailLosePrefilledOrder;
